import React from 'react';
import { BedIcon, BathIcon, ParkingIcon, ChevronRightIcon } from '@domain-group/fe-co-icon';
import MultiResolutionImage from '@domain-group/fe-co-multi-resolution-image';
var blankHouseLo = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-dream-homes/static/blank-house-lo_a50963d7.jpg";
var blankHouse = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-dream-homes/static/blank-house_6b55e958.png";
import * as styles from './allhomes-dream-homes-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var iconClasses = {
  bedrooms: BedIcon,
  bathrooms: BathIcon,
  carspaces: ParkingIcon
};
var getIcon = attributeName => {
  var Icon = iconClasses[attributeName];
  return ___EmotionJSX(Icon, {
    css: styles.icon,
    size: "regular"
  });
};
var AllhomesDreamHomesCard = _ref => {
  var attributesProp = _ref.attributes,
    _ref$isFirstCard = _ref.isFirstCard,
    isFirstCard = _ref$isFirstCard === void 0 ? false : _ref$isFirstCard,
    _ref$isDesktop = _ref.isDesktop,
    isDesktop = _ref$isDesktop === void 0 ? false : _ref$isDesktop,
    _ref$isLarge = _ref.isLarge,
    isLarge = _ref$isLarge === void 0 ? false : _ref$isLarge,
    listingUrl = _ref.listingUrl,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick,
    _ref$lowResThumbnail = _ref.lowResThumbnail,
    lowResThumbnail = _ref$lowResThumbnail === void 0 ? blankHouseLo : _ref$lowResThumbnail,
    _ref$highResThumbnail = _ref.highResThumbnail,
    highResThumbnail = _ref$highResThumbnail === void 0 ? blankHouse : _ref$highResThumbnail,
    suburb = _ref.suburb,
    state = _ref.state;
  var attributes = [];
  if (attributesProp) {
    ['bedrooms', 'bathrooms', 'carspaces'].forEach(attributeName => {
      if (attributeName in attributesProp) {
        attributes.push(___EmotionJSX("div", {
          key: attributeName,
          css: styles.attribute
        }, ___EmotionJSX("span", null, attributesProp[attributeName]), getIcon(attributeName)));
      }
    });
  }
  return ___EmotionJSX("div", null, ___EmotionJSX("div", {
    css: styles.card(isFirstCard, isDesktop, isLarge)
  }, ___EmotionJSX("a", {
    css: styles.homeLink,
    href: listingUrl,
    onClick: onClick
  }, ___EmotionJSX(MultiResolutionImage, {
    css: styles.homeImage,
    src: highResThumbnail,
    srcLowResolution: lowResThumbnail,
    alt: "A property in ".concat(suburb, ", ").concat(state)
  }), ___EmotionJSX("div", {
    css: styles.homeGradient
  }), ___EmotionJSX("div", null, ___EmotionJSX("span", {
    css: styles.suburb(isDesktop, isLarge),
    className: "allhomes-dream-homes__home-suburb"
  }, suburb, ", ", state), ___EmotionJSX("div", {
    css: styles.homeAttributesInline(isDesktop, isLarge),
    className: "allhomes-dream-homes__home-attributes-inline"
  }, attributes)), ___EmotionJSX("div", {
    css: styles.button(isDesktop, isLarge),
    className: "allhomes-dream-homes__button"
  }, ___EmotionJSX("span", {
    css: styles.buttonText
  }, "View property", ___EmotionJSX(ChevronRightIcon, {
    css: styles.buttonIcon,
    size: "custom"
  }))))));
};
export { AllhomesDreamHomesCard };